import { render, staticRenderFns } from "./FormAlert.vue?vue&type=template&id=bc6ad2b0&"
import script from "./FormAlert.vue?vue&type=script&lang=js&"
export * from "./FormAlert.vue?vue&type=script&lang=js&"
import style0 from "./FormAlert.vue?vue&type=style&index=0&id=bc6ad2b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports